import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UnknownAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { ShipmentDirection } from '../../@posturinn/client-react';
import { fetchShipments } from '../../actions/shipmentsActions';
import { IShipmentPagination } from '../../interfaces/reducers/shipmentsReducer';
import { RootState } from '../../store';

const useShipments = (pageActive: number, pageDelivered: number, direction: ShipmentDirection, cachingTime: number, includeHidden=false) => {
	const dispatch = useDispatch<ThunkDispatch<RootState, void, UnknownAction>>();
	const { shipmentsInbound, shipmentsInboundDelivered, shipmentsOutbound, shipmentsOutboundDelivered } = useSelector(
		({ shipmentsReducer }) => shipmentsReducer
	);
	let activeShipments: IShipmentPagination = null;
	let deliveredShipments: IShipmentPagination = null;
	if (direction === ShipmentDirection.Inbound) {
		activeShipments = shipmentsInbound;
		deliveredShipments = shipmentsInboundDelivered;
	} else {
		activeShipments = shipmentsOutbound;
		deliveredShipments = shipmentsOutboundDelivered;
	}
	/*useEffect(() => {
		if (!activeShipments.results[pageActive]) {
			dispatch(fetchShipments(pageActive, true, direction));
		}
		if (!deliveredShipments.results[pageDelivered]) {
			dispatch(fetchShipments(pageDelivered, false, direction));
		}
	}, [
		shipmentsInbound,
		shipmentsInboundDelivered,
		shipmentsOutbound,
		shipmentsOutboundDelivered,
		direction,
		pageActive,
		pageDelivered,
		dispatch,
		activeShipments,
		deliveredShipments,
	]);*/

	useEffect(() => {
		if (
			!activeShipments.fetched[pageActive] ||
			Math.abs(Date.now() - activeShipments.fetched[pageActive]) > cachingTime
		) {
			dispatch(fetchShipments(pageActive, true, direction, includeHidden));
		}

		if (
			!deliveredShipments.fetched[pageDelivered] ||
			Math.abs(Date.now() - deliveredShipments.fetched[pageDelivered]) > cachingTime
		) {
			dispatch(fetchShipments(pageDelivered, false, direction, includeHidden));
		}
		// page will reload if there are more hooks
		// eslint-disable-next-line
	}, [direction, pageActive, pageDelivered, includeHidden]);

	return {
		activeShipments,
		deliveredShipments,
	};
};

export default useShipments;
